module.exports = __webpack_public_path__ + "img/shangmao.4c99ffd4.png";